import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFormatterInr'
})
export class CurrencyFormatterInrPipe implements PipeTransform {

  // transform(value: any, currency?: any): any {
  //   console.log(value)
  //   // console.log(currency)
  //   // if(value){
  //     // if (currency === 'INR') {
  //       // return value ? value.toLocaleString('en-IN') : value;
  //       if(value == "") {
  //         return ""
  //       }else if(value == "Budget Not Set"){
  //         return "Budget Not Set";
  //       } else if(typeof value === 'string' && value != "Budget Not Set") {
  //         const numericValue = parseFloat(value);
  //         if (!isNaN(numericValue)) {
  //           return numericValue.toLocaleString(undefined, { maximumFractionDigits: 2 });
  //       } else {
  //           return value;
  //       }
  //         // return value ? +(+value).toLocaleString(undefined, { maximumFractionDigits: 2 }) : value;
  //       }else {
  //         return value ? value.toLocaleString(undefined, { maximumFractionDigits: 2 }) : value;
  //       }
  //     // } else {
  //     //   return value;
  //     // }
  //   // }
  // }
  
  transform(value: any): string {
    if(value == "Budget Not Set"){
      return "Budget Not Set";
    }else{
      return value.toLocaleString('en-US', { maximumFractionDigits: 2 });
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4057176511/src/src/app/shared/pipes/currency-formatter-inr.pipe.ts